export const DOCUMENT_MENTION_CAPTURE_PATTERN = '@document:([^\\s)]+(?: \\(\\d+\\)(?:\\.[^\\s)]+)?)?)';

export const createDocumentMentionRegex = (flags = 'g') =>
  new RegExp(DOCUMENT_MENTION_CAPTURE_PATTERN, flags);

